// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3UzXt","list":"PatternAutocomplete_list__rdDNa"};